<template>
    <div>

        <el-card class="search-form-card">

            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" class="common-input"></el-input>
                    <el-button type="primary" @click='request'>搜索</el-button>
                </el-form-item>
            </el-form>

        </el-card>

        <el-card>

            <div slot="header">
                <router-link  :to="{ path:'/serveCatalogUpdata',query: { callback:request } }">
                    <el-button type="primary">新增</el-button>
                </router-link>
            </div>

            <el-table
                :data="tableData"
                v-loading='loading'
                row-key="serialNumber"
                border
                lazy
                :load="load"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

                <el-table-column type="index" width='50px' ></el-table-column>

                <el-table-column label="服务名称" prop="title"></el-table-column>

                <el-table-column label="服务编码" prop="serialNumber"></el-table-column>

                <el-table-column label="关联公司" prop="company">
                    <template slot-scope="scope">
                        {{scope.row.company.title}}
                    </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/serveCatalogUpdata',
                                        query: { form:scope.row, type:'edit', callback:request }}">
                            <el-button type="text" >修改</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0072'" class="table-del-btn" type="text" @click="deleteRole(scope.$index, tableData, scope.row.serialNumber)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

        </el-card>

    </div>
</template>

<script>

import Pagination from '../../../components/Pagination'

import services from '../serve.services'


export default {

    components: { Pagination },

    data() {
        return {
            loading: true,
            tableData: [],
            form: {},
            url:'/serveCatalog'
        }
    },

    mounted() {
        this.request()
    },

    methods: {
        // 表格树
        load(tree, treeNode, resolve) {
            services.serviceList({parentNumber: tree.serialNumber})
                .then(res => resolve(res.list))
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 请求数据
        request() {
            this.tableData = []
            this.loading = false
            services.serviceList(this.form)
                .then(res =>this.tableData = res.list)
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 删除数据
        deleteRole(index, rows, serialNumber) {
            this.$confirm('此操作将永久删除该服务, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    services.serviceDelete({serialNumber})
                        .then(res => {
                            this.$message.success('删除成功!')
                           //子节点删除后刷新整个组件，跳转空白页再跳回来
                            this.$router.push({
                                path:'/redirect',
                                query:{
                                    url:'/serveCatalog'
                                }
                            })
                        })
                        .catch(err => this.$message.error(err.message))
                }).catch(() => this.$message.info('已取消删除'))
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
